import { useParams } from 'react-router-dom';
import { useExportParticipantCouponDetail, useExportParticipantCouponSummary, useExportParticipantList, useGetLuckyDrawDetailParticipantSummary, useLuckyDrawParticipantList } from '../../../providers/LuckyDraw.provider';

export function useLuckyDrawHookDetailTabParticipant() {
  const params = useParams<{ id: string }>();

  const participantList = useLuckyDrawParticipantList(params.id);
  const exportParticipantList = useExportParticipantList(params.id);
  const exportParticipantCouponDetail = useExportParticipantCouponDetail(params.id);
  const exportParticipantCouponSummary = useExportParticipantCouponSummary(params.id);
  const participantSummary = useGetLuckyDrawDetailParticipantSummary(params.id);

  return {
    participantList,
    exportParticipantList,
    exportParticipantCouponDetail,
    exportParticipantCouponSummary,
    participantSummary,
    params
  };
}
